/* eslint-disable import/prefer-default-export */
import { AUTH_TYPE } from 'feature/loading-management/utils/const';
import * as R from 'ramda';

const invalidVolume = R.anyPass([R.isNil, R.equals(NaN), R.gte(0)]);

const authorizationTypes = R.map(R.prop('value'), AUTH_TYPE);

// prettier-ignore
const authorizationVolumeTypes = R.without(
  ['SPECIFIC', 'UNLIMITED'],
  authorizationTypes
);
const renewalVolumeTypes = R.without(
  ['LIMITED', 'ONELOAD', 'ONETIME', 'SPECIFIC', 'UNLIMITED'],
  authorizationTypes
);

// invalidAuthorizationVolume :: Product -> Bool
const invalidAuthorizationVolume = R.converge(R.and, [
  R.o(R.includes(R.__, authorizationVolumeTypes), R.prop('authorizationType')),
  R.o(invalidVolume, R.prop('authorizationVolume')),
]);

// invalidRenewalVolume :: Product -> Bool
const invalidRenewalVolume = R.converge(R.and, [
  R.o(R.includes(R.__, renewalVolumeTypes), R.prop('authorizationType')),
  R.o(invalidVolume, R.prop('renewalVolume')),
]);

// invalidProduct :: Product -> Bool
export const invalidProduct = R.either(
  invalidAuthorizationVolume, //
  invalidRenewalVolume
);
